import { Box, Button, Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"
import { addIdForDataGrid } from "utils"
import { cSmileColumns, cSmileColumnsCN, cSmileColumnsSc } from "./columns"
import dayjs from "dayjs"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import SearchButton from "components/buttons/SearchButton"
import { alertConfirmDelete, alertSuccess } from "components/Alert"



const IsXpssDialog = ({ dialogOpen, setDialogOpen, data }) => {
  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [selectedDate, setSelectedDate] = useState(dayjs())
  const [selectionModel, setSelectionModel] = useState([])

  const getData = useCallback((date) => {
    const st = date.startOf("day").format("YYYY-MM-DD HH:mm:ss")
    const en = date.endOf("day").format("YYYY-MM-DD HH:mm:ss")
    ax.post("/branch/c-smile/getCSmileData", { IsXpssTmSt: st, IsXpssTmEn: en }).then(value => {
      if (value.data[data]) {
        let key = ""
        if (data === "invoices") key = "InvId"
        else if (data === "scInvoices") key = "ScInvId"
        else if (data === "crediteNotes") key = "CNId"
        setDataTable(addIdForDataGrid(value.data[data], key))
      }
    })
  }, [ax, data])

  const handleDateChange = useCallback((date) => {
    setSelectedDate(date)
  }, [])

  const handleDeleteCSmile = useCallback(() => {
    if (selectionModel.length === 0) {
      alert("กรุณาเลือกอย่างน้อย 1 รายการ")
      return
    }

    alertConfirmDelete(() => {
      let postData = {}
      let api = ""
      if (data === "invoices") {
        api = "/branch/c-smile/deleteCSmileInvoice"
        const invs = dataTable.filter(d => selectionModel.includes(d.InvId)).map(d => ({ InvId: d.InvId, InvNo: d.InvNo }))
        postData = { Invs: invs }
      } else if (data === "scInvoices") {
        api = "/branch/c-smile/deleteCSmileScInvoice"
        const scInvs = dataTable.filter(d => selectionModel.includes(d.ScInvId)).map(d => ({ ScInvId: d.ScInvId, XpssDocNum: d.XpssDocNum }))
        postData = { ScInvs: scInvs }
      } else if (data === "crediteNotes") {
        api = "/branch/c-smile/deleteCSmileCreditNote"
        const cns = dataTable.filter(d => selectionModel.includes(d.CNId)).map(d => ({ CNId: d.CNId, CNNo: d.CNNo }))
        postData = { CNs: cns }
      }
      ax.post(api, postData).then(value => {
        if (value.data) {
          getData(selectedDate)
          setSelectionModel([])
          alertSuccess("ลบข้อมูลเรียบร้อยแล้ว")
        }
      })

    })
  }, [ax, selectionModel, dataTable, getData, selectedDate, data])


  const columns = useMemo(() => {
    const invIsXpssColumns = [
      ...cSmileColumns,
      {
        field: "IsXpssTm",
        headerName: "วันที่ลง CSmile",
        width: 150,
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-",
      },
    ]
    const scInvIsXpssColumns = [
      ...cSmileColumnsSc,
      {
        field: "IsXpssTm",
        headerName: "วันที่ลง CSmile",
        width: 150,
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-",
      },
    ]
    const cnIsXpssColumns = [
      ...cSmileColumnsCN,
      {
        field: "IsXpssTm",
        headerName: "วันที่ลง CSmile",
        width: 150,
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-",
      },
    ]
    if (data === "invoices") return invIsXpssColumns
    else if (data === "scInvoices") return scInvIsXpssColumns
    else if (data === "crediteNotes") return cnIsXpssColumns
    else return []
  }, [data])

  useEffect(() => {
    if (dialogOpen) {
      const today = dayjs()
      setSelectedDate(today)
      getData(today)
    }
  }, [dialogOpen, getData])

  return (
    <Dialog open={dialogOpen} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="md">
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายการลง CSmile แล้ว"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} gap={2}>
          <BoxFR>
            <Button variant="contained" color="secondary" onClick={handleDeleteCSmile}>ลบข้อมูล CSmile ที่เลือก</Button>
            <Box flex={1} />
            <DesktopDatePicker
              label="วันที่ลง CSmile"
              value={selectedDate}
              onChange={handleDateChange}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => <TextField size="small" {...params} sx={{ width: 180 }} />}
            />
            <SearchButton onClick={() => getData(selectedDate)} />
          </BoxFR>
          <DataGridCellExpand
            checkboxSelection
            hideFooter
            rows={dataTable}
            columns={columns}
            selectionModel={selectionModel}
            onSelectionModelChange={(newSelection) => setSelectionModel(newSelection)}
            sx={{ height: 500 }}
          />
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={null}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null}
      />
    </Dialog>
  )
}

export default React.memo(IsXpssDialog)
